import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";

const SITE = "https://serenatti.com";

const PAGE_META = {
  "/": {
    title: "Evidence-Based Skincare & Healthy Aging | SERENATTI",
    description:
      "Plain-language skincare and healthy-aging information written by a registered nurse. Real research, no hype.",
  },
  "/learn": {
    title: "Skincare Science Articles, Written by a Nurse | SERENATTI",
    description:
      "Evidence-based articles on skin health, aging, and skincare myths — sources cited.",
  },
  "/about": {
    title: "About SERENATTI — RN-Founded Skincare Education",
    description:
      "Founded by a registered nurse to make skincare and healthy-aging science understandable.",
  },
  "/contact": {
    title: "Contact SERENATTI",
    description: "Questions or feedback about our educational articles.",
  },
};

function upsertMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.rel = "canonical";
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function SEO() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Article pages set their own title in Article.jsx
    if (pathname.startsWith("/learn/") && pathname !== "/learn") {
      upsertCanonical(`${SITE}${pathname}`);
      return;
    }
    const meta = PAGE_META[pathname] || PAGE_META["/"];
    document.title = meta.title;
    upsertMeta("description", meta.description);
    upsertMeta("og:title", meta.title, "property");
    upsertMeta("og:description", meta.description, "property");
    upsertMeta("og:type", "website", "property");
    upsertMeta("og:url", `${SITE}${pathname}`, "property");
    upsertMeta("twitter:card", "summary_large_image");
    upsertMeta("twitter:title", meta.title);
    upsertMeta("twitter:description", meta.description);
    upsertCanonical(`${SITE}${pathname}`);
  }, [pathname]);

  return null;
}
